var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
if (!customElements.get("wishlist-modal")) {
  class WishlistModal extends ModalDialog {
    constructor() {
      super();
      __publicField(this, "handleWishedButtonStatus", () => {
        const wishlistData = JSON.parse(localStorage.getItem(window.WISHLIST_PARAMS.key)) || [];
        
        for (let item of wishlistData) {
          const handle = item.split(";")[0];
          let wishedButtons = document.querySelectorAll(`.sm-quick-wish__submit[data-product-handle="${handle}"]`);
          wishedButtons.forEach((element) => {
            element.classList.add("active");
          });
        }
      });
      // 新增方法：用于更新愿望清单气泡中的数量
      __publicField(this, "updateWishlistCountBubble", () => {
        const wishlistData = JSON.parse(localStorage.getItem(window.WISHLIST_PARAMS.key)) || [];
        const count = wishlistData.length;
        
        // 找到气泡元素，它的 ID 应该和你的 HTML 匹配
        const countElement = document.getElementById("bottom-toolbar-wishlist-count"); 
        
        if (countElement) {
          countElement.textContent = count;
          countElement.dataset.wishlistCount = count;
        }
        
      });
      this.getElements();
      this.setupEventListeners();
      this.handleWishedButtonStatus();
      // 在实例创建时立即调用，以显示正确的初始数量
      this.updateWishlistCountBubble();
    }
    
    open() {
      this.createListItem();
      super.open();
    }
    close() {
      super.close();
      this.elements.empty.classList.add("hidden");
      this.elements.details.classList.add("hidden");
      this.elements.loading.classList.remove("hidden");
    }
    getElements() {
      this.elements = {
        details: this.querySelector(".sm-wishlist__details"),
        list: this.querySelector(".sm-wishlist__list"),
        empty: this.querySelector(".sm-wishlist__empty"),
        loading: this.querySelector(".sm-wishlist__loading")
      };
    }
    
    setupEventListeners() {
      this.elements.list.addEventListener("click", (event) => {
        var _a, _b, _c, _d, _e;
        const itemDeleteElement = event.target.closest(".sm-wishlist__item-delete");
        if (itemDeleteElement) {
          window.messageBox({
            title: (_b = (_a = window.wishlistStrings) == null ? void 0 : _a.tips) == null ? void 0 : _b.areYouSure,
            message: (_e = (_d = (_c = window.wishlistStrings) == null ? void 0 : _c.tips) == null ? void 0 : _d.deleteItem) == null ? void 0 : _e.replace("{{ item }}", ""),
            showCancelButton: true,
            callback: (type) => {
              if (type === "confirm") {
                const parentItemElement = itemDeleteElement.closest(".sm-wishlist__item");
                const { productHandle, variantId } = parentItemElement.dataset;
                const wishlistData = JSON.parse(localStorage.getItem(window.WISHLIST_PARAMS.key)) || [];
                const newWishlistData = wishlistData.filter((item) => item !== `${productHandle};${variantId}`);
                localStorage.setItem(
                  window.WISHLIST_PARAMS.key,
                  JSON.stringify([...new Set(newWishlistData)].slice(0, 50))
                );
                parentItemElement.remove();
                
                // 在删除操作完成后调用，更新气泡数量
                this.updateWishlistCountBubble();

                if (newWishlistData.length === 0) {
                  this.elements.empty.classList.remove("hidden");
                  this.elements.details.classList.add("hidden");
                }
                const someHandle = newWishlistData.some((item) => item.split(";")[0] === productHandle);
                if (!someHandle) {
                  const wishedButtons = document.querySelectorAll(
                    `.sm-quick-wish__submit[data-product-handle="${productHandle}"]`
                  );
                  wishedButtons.forEach((element) => {
                    element.classList.remove("active");
                  });
                }
              }
            }
          });
        }
      });
    }
    async createListItem() {
      const wishlistData = JSON.parse(localStorage.getItem(window.WISHLIST_PARAMS.key)) || [];
      if (wishlistData.length > 0) {
        const urls = wishlistData.map((item) => {
          const [handle, variantId] = item.split(";");
          return `${window.Shopify.routes.root}products/${handle}?variant=${variantId}&section_id=wishlist-product`;
        });
        this.elements.loading.classList.remove("hidden");
        const responses = await window.fetchWithConcurrencyLimit(urls, "text");
        let html = "";
        responses.forEach((responseText, index) => {
          const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
          const replaceElement = responseHTML.querySelector(".shopify-section");
          const itemElement = replaceElement.querySelector(".sm-wishlist__item");
          itemElement.dataset.productHandle = wishlistData[index].split(";")[0];
          itemElement.dataset.variantId = wishlistData[index].split(";")[1];
          html += replaceElement.innerHTML;
        });
        window.setInnerHTML(this.elements.list, html);
        this.elements.loading.classList.add("hidden");
        this.elements.details.classList.remove("hidden");
      } else {
        this.elements.loading.classList.add("hidden");
        this.elements.empty.classList.remove("hidden");
      }
    }
  }
  customElements.define("wishlist-modal", WishlistModal);
}